import { deepMerge } from 'js/utils/Utils'

const defaults = {
  src: {
    list: '<ul></ul>',
    listItem: '<li></li>',
  },
  gridLength: {
    desktop: 72,
    mobile: 39,
  },
  style: {
    opacity: 0.2,
    oddColor: '#ff0000',
    evenColor: '#00ff00',
  },
  visibleFromBeginning: false,
}

class GridHelper {
  constructor(options = {}) {
    this.src = {}
    this.visible = false

    // selectors
    this.$container = null
    this.$gird = null
    this.$listItemAll = []

    deepMerge(this, defaults, options)
  }

  init() {
    if (window.innerWidth >= 768) {
      this.gridLength = this.gridLength.desktop
    } else {
      this.gridLength = this.gridLength.mobile
    }

    this._setElement()
    this._setInitStyle()
    this.addEventListeners()
    if (this.visibleFromBeginning) {
      this._setSwitch()
    }
  }

  _setElement() {
    this.$container = document.createElement('div')
    this.$container.innerHTML = this.src.list
    document.body.appendChild(this.$container)

    this.$grid = this.$container.querySelector('ul')
    this.listItemSrc = ''

    for (let i = 0; i < this.gridLength; i++) this.listItemSrc += this.src.listItem
    this.$grid.innerHTML = this.listItemSrc
    this.$listItemAll = this.$grid.querySelectorAll('li')
  }

  _setInitStyle() {
    deepMerge(this.$container.style, {
      display: 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      width: 'calc( var(--vw) * 100 )',
      height: 'calc( var(--vh) * 100 )',
      zIndex: 99999,
      pointerEvents: 'none',
      userSelect: 'none',
      opacity: `${this.style.opacity}`,
      fontSize: 0,
      letterSpacing: 0,
      lineHeight: 0,
    })

    deepMerge(this.$grid.style, {
      display: 'flex',
      width: '100%',
      height: '100%',
    })

    this.$listItemAll.forEach(($item, i) => {
      const index = i + 1
      const isOdd = index % 2 === 0

      $item.dataset['num'] = index

      deepMerge($item.style, {
        width: ` ${100 / this.gridLength}%`,
        height: '100%',
      })

      if (isOdd) {
        deepMerge($item.style, {
          backgroundColor: `${this.style.oddColor}`,
        })
      } else {
        deepMerge($item.style, {
          backgroundColor: `${this.style.evenColor}`,
        })
      }
    })
  }

  addEventListeners() {
    window.addEventListener('keydown', (e) => {
      if (e && e.key && e.key === 'g') {
        this._setSwitch()
      }
    })
  }

  _setSwitch() {
    this.visible = !this.visible
    if (!this.visible) {
      this.$container.style.display = 'none'
    } else {
      this.$container.style.display = 'block'
    }
  }
}

export default new GridHelper()